import { FormattedMessage } from "react-intl";

export default function Footer() {
    return(
        <div className="footer">
            <a href="privacy"><FormattedMessage id="privacy"/></a>
            |
            <a href="imprint"><FormattedMessage id="imprint"/></a>
            |
            <a href="contact"><FormattedMessage id="contact"/></a>
        </div>
    );
}